import axios from "utils/axios";
import { toJS } from "mobx";
import * as APITypes from 'constants/API';
import { preFillUserFields, getEligibleProposerList } from "./utils";
import FamilyDetailsStore from "../store/FamilyDetailsStore";
import fetchSalutationMaster from 'utils/fetchSalutationMaster'
import AuthStore from "modules/login/store/AuthStore";
import FamilyMemberTypeEnum from "../FamilymemberTypeEnum";
import { addNewMember, updateValue } from "modules/family-details-form/non-individual-journey-form/utils";
import employeesList from "./employeesList";
import generateRandomString from "utils/generateRandomString";
import { EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, INDIVIDUAL, KEYMAN, MWP_ACT, PARTNERSHIP } from "constants/ CustomerType";

const fetchNationalityMaster = async () => {
    const response = await axios.get(APITypes.NATIONALITY_MASTER)
    return response.data
}

const monthlyIncomeMaster = async () => {
    const response = await axios.get(APITypes.MONTHLY_INCOME_MASTER)
    return response.data
}

const initialDefaults = async (formController, journeyId, journeyData, expenseList, lifeCoverList, emiValueCallBack) => {
    let nationalMasterList = await fetchNationalityMaster();
    let salutationMasterList = await fetchSalutationMaster();
    let monthlyIncomeMasterList = await monthlyIncomeMaster();
    FamilyDetailsStore.updateNationalityList(nationalMasterList);
    FamilyDetailsStore.updateLifeCoverList(lifeCoverList);
    FamilyDetailsStore.updateSalutationList(salutationMasterList);
    FamilyDetailsStore.updateMonthlyIncomelist(monthlyIncomeMasterList);

    let familyDetails = toJS(AuthStore.journeyData.family_details_list)
    let updatedJourneyData = toJS(AuthStore.journeyData)
    let validJourneyTypes = [EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, PARTNERSHIP, KEYMAN];
  
if(employeesList.length === 0){
    if (AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_A || AuthStore.journeyTypeName === HUF || AuthStore.journeyTypeName === PARTNERSHIP || AuthStore.journeyTypeName === KEYMAN) {
            employeesList.push({
            "name": "employer",
            "defaultSelected": true,
            "label": "Employer",
            "memberType": FamilyMemberTypeEnum.EMPLOYER
        })
    }

    if (validJourneyTypes.includes(AuthStore.journeyTypeName) ) {
        for (let index = 1; index <= 5; index++) {
            employeesList.push({
                "name": "employee" + index,
                "defaultSelected": index === 1 ? true : false,
                "label": "Employee " + index,
                "memberType": FamilyMemberTypeEnum.EMPLOYEE
            })
        }
    } else {

        for (let index = 1; index <= 5; index++) {
            employeesList.push({
                "name": "family_member" + index,
                "defaultSelected": index === 1 ? true : false,
                "label": "Family Member " + index,
                "memberType": FamilyMemberTypeEnum.FAMILYMEMBER
            })
        }

    }
}

    //let isMemberDetailsFillUp = familyDetails.some((item) => item.first_name)
    // FamilyDetailsStore.updateIsFamilyDetailsFillUp(isMemberDetailsFillUp)

    let familyFieldList = preFillUserFields(
        journeyData,
        lifeCoverList,
        nationalMasterList,
        salutationMasterList,
        monthlyIncomeMasterList
    )

    // let details = {}
    // let termNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 4)
    // let gmmNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 1)
    // let childNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 2)
    // let retirementNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 3)
    // let healthNeedData = journeyData.family_product_details_list.find((item) => item.is_selected && !item.la_removed && item.need === 5)

    // if(Object.keys(details).length === 0 && termNeedData) { details = termNeedData}
    // if(Object.keys(details).length === 0 && gmmNeedData) { details = gmmNeedData}
    // if(Object.keys(details).length === 0 && childNeedData) { details = childNeedData}
    // if(Object.keys(details).length === 0 && retirementNeedData) { details = retirementNeedData}
    // if(Object.keys(details).length === 0 && healthNeedData) { details = healthNeedData}

    // familyFieldList.forEach((member) => {

    //     let fieldsList = member.fields
    //     member.fields.forEach((item) => {
    //         if (item.name === "id") { 
    //             if(item.value === details.family)
    //                 fieldsList.forEach((field) => { if(field.name === 'life_assured') field.value = true }) 

    //             if(item.value === details.proposer_family)
    //                 fieldsList.forEach((field) => { if(field.name === 'proposer') field.value = true }) 
    //         }
    //     })
    // })

    familyFieldList.forEach(item => formController.$("members").add(item)
    )

    // if (AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B) {
    //     if (familyFieldList[0].name === "employee1") {

    //         updateValue(formController, "employee1", "life_assured", true)
    //         updateValue(formController, "employee1", "proposer", true)

    //     }
    // }
    // if (AuthStore.journeyTypeName === MWP_ACT) {
    //     if (familyFieldList[0].name === "family_member1") {
    //         updateValue(formController, "family_member1", "life_assured", true)
    //         updateValue(formController, "family_member1", "proposer", true)

    //     }
    // }

    // formController.$("gender").set("extra", {
    //     ...formController.$("gender").extra,
    //     optionList: [
    //         { id: 1, label: 'Male', value: 'Male' },
    //         { id: 2, label: 'Female', value: 'Female' }
    //     ],
    // });

    // if (AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_A || AuthStore.journeyTypeName === HUF || AuthStore.journeyTypeName === PARTNERSHIP || AuthStore.journeyTypeName === KEYMAN) {
    //     if (familyFieldList[1].name === "employee1") {
    //         updateValue(formController, "employee1", "life_assured", true)
    //     }
    //     if (familyFieldList[1].name === "family_member1") {
    //         updateValue(formController, "family_member1", "life_assured", true)

    //     }
    // }

    //  if ()
    // familyData.forEach((item) => {
    //     if (item[1].value.life_assured) {
    //         getEligibleProposerList(item, formController, journeyData)
    //     }
    // })
    let monthlyExpense = expenseList.find(item => item.name === 'Monthly Expense Details')

    let liabilitiesDetails = expenseList.find(item => item.name === 'Liability Details')
    let currentSavingsDetails = expenseList.find(item => item.name === 'Savings & Investments')
    let monthlyEMIDetails = expenseList.find(item => item.name === 'Monthly EMI')

    let lastEmiType = monthlyEMIDetails.expense_label[monthlyEMIDetails.expense_label.length - 1].label_name
    lastEmiType = lastEmiType.toLowerCase().replaceAll(" ", '_')

    formController.$("journey_id").value = journeyId

    let selfsExpenseList = familyDetails.find((item) => item.family_member_type.toLowerCase() === 'employee' || item.family_member_type.toLowerCase() === 'family_member').expense_list
    let selfsEmiList = familyDetails.find((item) => item.family_member_type.toLowerCase() === 'employee' || item.family_member_type.toLowerCase() === 'family_member').user_emi

    createExpenseFieldObject(formController, 'monthly_expense', monthlyExpense.expense_label)
    createExpenseFieldObject(formController, 'liabilities', liabilitiesDetails.expense_label)
    createExpenseFieldObject(formController, 'savings', currentSavingsDetails.expense_label)
    createExpenseFieldObject(formController, 'monthly_emi', monthlyEMIDetails.expense_label, selfsExpenseList, selfsEmiList, emiValueCallBack, lastEmiType)
}

const createExpenseFieldObject = (formController, field_name, expense_type, selectedExpenseList, selectedEmiList = [], emiValueCallBack, lastEmiType) => {
    expense_type.forEach((item) => {
        let expenseTypeObj = {}
        expenseTypeObj.label = item.label_name,
            expenseTypeObj.disabled = true,
            expenseTypeObj.name = item.label_name.toLowerCase().replaceAll(" ", '_'),
            expenseTypeObj.value = {}
        expenseTypeObj.extra = {
            optionList: [],
            bottomSheetTitle: "Select an Option"
        }
        let optionList = []
        item.expense_range.forEach(expense_range_item => {
            optionList.push({
                id: expense_range_item.id,
                label: expense_range_item.value,
                value: expense_range_item.mid_value,
            })
        })
        expenseTypeObj.extra.optionList = optionList

        let selectedExpenseOption = selectedExpenseList?.find(expense => expense.expense_label === expenseTypeObj.label && expenseTypeObj.extra.optionList.some((item) => item.id === expense.expense_range_id))

        if (selectedExpenseOption !== undefined) {
            expenseTypeObj.value = {
                id: selectedExpenseOption.expense_range_id,
                label: selectedExpenseOption.expense_range_key,
                journeyExpenseId: selectedExpenseOption.id
            }
            expenseTypeObj.disabled = false
        }

        formController.$(field_name).add(expenseTypeObj)

        if (field_name === "monthly_emi") {

            let selectedEmiOption = selectedEmiList.find(expense => expense.expense_label === expenseTypeObj.label)

            selectedEmiList.forEach(expense => {
                expense.expense_label === expenseTypeObj.label
            })

            if (selectedEmiOption !== undefined) {
                expenseTypeObj.disabled = false
            }

            formController.$(field_name).add(expenseTypeObj)

            createEmiSectionFieldObject(formController, field_name, expenseTypeObj.name, item.expense_range, selectedEmiList, emiValueCallBack, lastEmiType)

        } else {
            formController.$(field_name).add(expenseTypeObj)
        }
    })
}

const createEmiSectionFieldObject = (formController, fieldName, expenseName, expenseRange, selectedEmiList, emiValueCallBack, lastEmiType) => {


    let selectedExpenseOption = selectedEmiList.find(expense => expense.expense_label.toLowerCase().replaceAll(" ", '_') === expenseName)


    // Option Ranges
    let fieldObject = {}
    fieldObject.label = "option-range"
    fieldObject.name = "option_range"
    fieldObject.disabled = true

    let optionList = []
    expenseRange.forEach(expense_range_item => {
        optionList.push({
            id: expense_range_item.id,
            label: expense_range_item.value,
            value: expense_range_item.mid_value,
        })
    })
    fieldObject.extra = {
        optionList: optionList
    }
    fieldObject.value = {}

    if (selectedExpenseOption !== undefined) {
        fieldObject.value = {
            id: selectedExpenseOption.expense_range,
            label: selectedExpenseOption.expense_range_key,
            value: selectedExpenseOption.value,
            journeyExpenseId: selectedExpenseOption.id
        }
    }

    formController.$(fieldName).$(expenseName).add(fieldObject)


    // Paid Years
    fieldObject = {}

    fieldObject.label = "Paid"
    fieldObject.name = "paid_years"
    fieldObject.disabled = true

    let paidYearsRangeOptionList = Array.from({ length: 30 }, (_, i) => {
        return {
            id: i,
            label: "" + i,
            value: i,
        }
    })

    fieldObject.extra = {
        optionList: paidYearsRangeOptionList
    }
    fieldObject.value = {}

    if (selectedExpenseOption !== undefined) {
        fieldObject.value = {
            id: selectedExpenseOption.paid_loan_tenure,
            label: selectedExpenseOption.paid_loan_tenure,
            value: selectedExpenseOption.paid_loan_tenure,
        }
    }

    formController.$(fieldName).$(expenseName).add(fieldObject)

    // Total years
    fieldObject = {}

    fieldObject.label = "Total"
    fieldObject.name = "total_years"
    fieldObject.disabled = true

    let totalYearsRangeOptionList = Array.from({ length: 30 }, (_, i) => {
        return {
            id: i + 1,
            label: i + 1,
            value: i + 1,
        }
    })

    fieldObject.extra = {
        optionList: totalYearsRangeOptionList
    }

    fieldObject.value = {}

    if (selectedExpenseOption !== undefined) {
        fieldObject.value = {
            id: selectedExpenseOption.total_loan_tenure,
            label: selectedExpenseOption.total_loan_tenure,
            value: selectedExpenseOption.total_loan_tenure,
        }
    }

    formController.$(fieldName).$(expenseName).add(fieldObject)

    /*  in the below function, if the expenseName and the lastEmiType is same, then it implieas that the initialValues are done loading, once it is done loading, we can set the  show_emi_fields to true which will render the emi filds onto the screen also set the formObserver in the emiValueCallBack function */

    if (emiValueCallBack) { //// TODO check this logic just fixed it for temp purpose

        emiValueCallBack(expenseName, lastEmiType)
    }

}


export default initialDefaults;